var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashImgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 .333H1A.667.667 0 0 0 .333 1v12a.667.667 0 0 0 .667.667h12a.667.667 0 0 0 .667-.667V1A.667.667 0 0 0 13 .333zm-4.667 12H1.667V7.668h6.666v4.667zm0-6H1.667V1.667h6.666v4.667zm4 6H9.667V1.668h2.666v10.667z",
    fill: "#445bc7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashImgActive);
export default __webpack_public_path__ + "static/media/dash-img-active.de0ecc54.svg";
export { ForwardRef as ReactComponent };